import * as React from 'react';

import FadeIn from '@/components/FadeIn/FadeIn';
import Image from 'next/image';

const COMPLIANCE = [
  {
    img: '/images/about/about-soc2.png',
    alt: 'AICPA SOC 2',
    title: 'SOC 2 Type 2 Compliant',
    desc: '',
  },
  {
    img: '/images/about/about-gdpr.png',
    alt: 'GDPR',
    title: 'General Data Protection Regulation Compliant',
    desc: '',
  },
];

const TrustCompliance: React.FC = () => (
  <section className='bg-white py-16 md:py-24'>
    <div className='container mx-auto px-4 md:px-8 xl:px-20 text-center'>
      <FadeIn variant='down' delay={0.2}>
        <h2 className='text-4xl md:text-[44px] font-medium mb-6'>
          Built on <span className='text-blue-500'>Trust</span>. Backed by Compliance.
        </h2>
        <p className='text-black/60 md:text-[24px] mb-12 mx-4'>
          Our systems are independently audited and globally compliant, ensuring your information
          stays secure and respected.
        </p>
      </FadeIn>
      <div className='flex flex-col md:flex-row justify-center gap-12 md:gap-24'>
        {COMPLIANCE.map((item, idx) => (
          <FadeIn
            key={idx}
            variant='up'
            delay={0.3 + idx * 0.1}
            className='flex-1 flex flex-col items-center'
          >
            <div className='mb-5 max-h-[360px]'>
              <Image src={item.img} alt={item.alt} width={380} height={380} />
            </div>
            <div className='text-[24px] font-medium'>{item.title}</div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default TrustCompliance;
